import { render, staticRenderFns } from "./approveDetail_reportItem.vue?vue&type=template&id=0cd9d97f&scoped=true"
import script from "./approveDetail_reportItem.vue?vue&type=script&lang=js"
export * from "./approveDetail_reportItem.vue?vue&type=script&lang=js"
import style0 from "./approveDetail_reportItem.vue?vue&type=style&index=0&id=0cd9d97f&scoped=true&lang=scss"
import style1 from "./approveDetail_reportItem.vue?vue&type=style&index=1&id=0cd9d97f&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd9d97f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cd9d97f')) {
      api.createRecord('0cd9d97f', component.options)
    } else {
      api.reload('0cd9d97f', component.options)
    }
    module.hot.accept("./approveDetail_reportItem.vue?vue&type=template&id=0cd9d97f&scoped=true", function () {
      api.rerender('0cd9d97f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/storeFeedback/approveReport/approveDetail_reportItem.vue"
export default component.exports